/** Inclusive, date-only event window shared by the wizard and its write boundary. */
export function eventCreationDateErrors(start?: string | null, end?: string | null) {
  const valid = (value: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
  };
  const errors: { start?: string; end?: string } = {};
  if (!start) errors.start = 'Choose an event start date.';
  else if (!valid(start)) errors.start = 'Enter a valid event start date.';
  if (!end) errors.end = 'Choose an event end date.';
  else if (!valid(end)) errors.end = 'Enter a valid event end date.';
  else if (start && !errors.start && end < start) errors.end = 'End date must be on or after the start date.';
  return errors;
}
